import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IPortalNoteModel } from '@apps-common/types/portal/portal-note'

export const QUERY_GET_PORTAL_NOTES = (entityId?: string) => ['getPortalNotes', entityId].filter(Boolean)

export const getPortalNotes = async (entityId: string): Promise<IPortalNoteModel[]> =>
  axios.get(`/portalnotes/getnotes?entityId=${entityId}`).then((res) => res.data?.data)

type QueryFnType = typeof getPortalNotes

type Props = {
  config?: QueryConfig<QueryFnType>
  entityId: string
}

export const useGetPortalNotes = ({ config, entityId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: QUERY_GET_PORTAL_NOTES(entityId),
    queryFn: () => getPortalNotes(entityId)
  })
